import http from "../http-common";

class NutsDataService {
  getNuts0() {
    return http.get("/nuts0");
  }
  getNuts1(nuts0code: string) {
    return http.get(`/nuts1/${nuts0code}`);
  }
  getNuts2(nuts1code: string) {
    return http.get(`/nuts2/${nuts1code}`);
  }
  getNuts3(nuts2code: string) {
    return http.get(`/nuts3/${nuts2code}`);
  }
}

export default new NutsDataService();
